import * as angular from "angular";
import uiRouter, {StateProvider, UrlRouterProvider} from "@uirouter/angularjs";
import "angular-animate";
import "angular-file-upload";
import "angular-formly";
import "angular-formly-templates-bootstrap";
import "angular-messages";
import "angular-moment";
import "angular-monash";
import "angular-sanitize";
import "angular-ui-bootstrap";
import "angularjs-toaster";
import "ng-file-upload";
import "ng-tags-input";
import "moment";
import "monash-user-admin-ui";
import {AuthModule} from "../shared/auth/auth.module";

export const AdminModule = angular
    .module("admin", [
        "ngAnimate",
        "ui.bootstrap",
        uiRouter,
        "ngMessages",
        "angularFileUpload",
        "angular-monash",
        "angularMoment",
        "monash-user-admin-ui",
        "ngFileUpload",
        "ngTagsInput",
        "formly",
        "formlyBootstrap",
        "toaster",
        AuthModule
    ])

    .config(($stateProvider: StateProvider) => {
        $stateProvider
            .state("admin", {
                parent: "app",
                abstract: true,
                url: "/admin",
                template: require("./admin.layout.html")
            })

            .state("admin.home", {
                url: "",
                template: require("./home.html"),
            })

            .state("admin.users", {
                url: "/users",
                component: "users"
            })

            .state("admin.institution-csv", {
                url: "/institutions/csv",
                template: require("./institution-csv.html")
            })

            .state("admin.blocked-courses-csv", {
                url: "/blocked-courses/csv",
                template: require("./blocked-courses-csv.html")
            })

            .state("admin.discipline-csv", {
                url: "/disciplines/csv",
                template: require("./discipline-csv.html")
            })

            .state("admin.teaching-periods-csv", {
                url: "/teaching-periods/csv",
                template: require("./teaching-periods-csv.html")
            });
    })

    .name;




// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/admin/admin.module.ts